import type { ChoiceOption } from "../data/schemas.js";

export interface ChoiceSubmission {
  optionId: string;
  selected: ChoiceOption;
  /** true/false=有明确对错；null=开放性回答（如"我还不确定"）。 */
  correct: boolean | null;
}

/**
 * 处理 guess / design / conclude / exam 四类单选题提交。纯函数，不产生副作用、不发事件——
 * 事件与状态推进由 mission-engine 统一编排（tech/108 §4.4）。
 */
export function submitChoice(options: ChoiceOption[], optionId: string): ChoiceSubmission {
  const selected = options.find((option) => option.id === optionId);
  if (!selected) {
    throw new Error(`[choice-controller] 未知选项：${optionId}`);
  }
  const correct = selected.correct ?? null;
  return { optionId, selected, correct };
}
